import React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";

// Generic warning/confirmation modal for Live Labor kiosk transitions.
// Used both for entering kiosk mode (tone "amber") and exiting it back to the
// login screen (tone "rose", a destructive action).
function LiveLaborConfirmModal(props) {
  const {
    open,
    handleClose,
    onConfirm,
    title,
    message,
    confirmLabel,
    tone = "rose",
  } = props;

  const tones = {
    rose: {
      icon: "text-rose-800",
      confirm: "bg-rose-200 hover:bg-rose-300 text-rose-800",
    },
    amber: {
      icon: "text-amber-600",
      confirm: "bg-violet-700 hover:bg-violet-900 text-white",
    },
  };
  const t = tones[tone] ?? tones.rose;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 440,
    maxHeight: 800,
    bgcolor: "background.paper",
    border: "2px solid #E2E8F0",
    borderRadius: "15px",
    boxShadow: 24,
    p: 4,
    overflowY: "auto",
  };

  return (
    <Modal
      open={open}
      onClose={() => handleClose()}
      aria-labelledby="live-labor-confirm-title"
      aria-describedby="live-labor-confirm-description"
    >
      <Box sx={style}>
        <div
          className="absolute right-2 top-2 text-gray-500 cursor-pointer"
          onClick={() => handleClose()}
        >
          <CloseIcon />
        </div>
        <div>
          <div className="flex items-center space-x-2">
            <div className={t.icon}>
              <WarningIcon style={{ marginBottom: "1px" }} />
            </div>
            <h3 className="text-2xl text-slate-900">{title}</h3>
          </div>
          <p className="text-slate-500 text-sm mt-4">{message}</p>
          <div className="w-full flex justify-end mt-8">
            <div className="flex space-x-3">
              <div
                className={`px-8 py-2 ${t.confirm} rounded-lg text-base w-fit cursor-pointer`}
                onClick={() => onConfirm()}
              >
                {confirmLabel}
              </div>
              <div
                className="px-8 py-2 bg-white border border-violet-700 text-violet-700 hover:bg-slate-100 rounded-lg text-base w-fit cursor-pointer"
                onClick={() => handleClose()}
              >
                Cancel
              </div>
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default LiveLaborConfirmModal;
